var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DBE4F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1667 28.666H33.8334C29.8334 28.666 27.1667 30.666 27.1667 35.3327V44.666C27.1667 49.3327 29.8334 51.3327 33.8334 51.3327H47.1667C51.1667 51.3327 53.8334 49.3327 53.8334 44.666V35.3327C53.8334 30.666 51.1667 28.666 47.1667 28.666ZM47.7934 36.786L43.62 40.1193C42.74 40.826 41.62 41.1727 40.5 41.1727C39.38 41.1727 38.2467 40.826 37.38 40.1193L33.2067 36.786C33.0027 36.6167 32.8721 36.375 32.8423 36.1115C32.8125 35.8481 32.8857 35.5833 33.0467 35.3727C33.3934 34.946 34.02 34.866 34.4467 35.2127L38.62 38.546C39.6334 39.3593 41.3534 39.3593 42.3667 38.546L46.54 35.2127C46.9667 34.866 47.6067 34.9327 47.94 35.3727C48.2867 35.7993 48.22 36.4393 47.7934 36.786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTicket);
export default __webpack_public_path__ + "static/media/empty_ticket.b26ef4003379687c76f3020c6fb99c19.svg";
export { ForwardRef as ReactComponent };